<app-modal-form #modal [modalConfig]="modalConfig" [modalOptions]="modalOptions">
  <app-section-loader *ngIf="isFirstLoad" class="modal-nilai-invoice__loader" />

  <app-card-empty
    *ngIf="hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_SALES_ORDER"
    text="Data invoice tidak dapat dimuat."
  />

  <app-card-empty
    *ngIf="isEmpty && !hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_SALES_ORDER"
    text="Belum terdapat invoice."
  />

  <!--
    Tabel hanya disembunyikan, bukan dilepas dari DOM. `BaseDatasource.disconnect()` memanggil
    `tableSubject.complete()`, jadi begitu MatTable dilepas oleh `*ngIf` subject-nya mati dan
    baris tidak pernah muncul lagi.
  -->
  <div [class.d-none]="isFirstLoad || hasError || isEmpty">
    <div class="table-responsive">
      <table
        [dataSource]="dataSource"
        class="table w-100 table-row-bordered align-middle nilai-invoice-table"
        mat-table
      >
        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
          <th
            *matHeaderCellDef
            [ngClass]="{
              'w-80px text-center': tableColumn.key === 'actions',
              'text-nowrap': tableColumn.key === 'so_code' || tableColumn.key === 'total_invoice',
            }"
            mat-header-cell
          >
            <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
              {{ tableColumn.title }}
            </app-table-content>
          </th>

          <td
            *matCellDef="let element"
            [ngClass]="{
              'w-80px text-center': tableColumn.key === 'actions',
              'text-nowrap': tableColumn.key === 'so_code' || tableColumn.key === 'total_invoice',
            }"
            mat-cell
          >
            <ng-container [ngSwitch]="tableColumn.key">
              <!-- Total QTY: kuantitas di baris pertama, berat/satuan jual di baris kedua. -->
              <div *ngSwitchCase="'total_qty'">
                <app-table-content
                  [count]="2"
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'text'"
                >
                  <div>{{ element['total_qty'] }}</div>
                  <div class="modal-nilai-invoice__weight">{{ element['weight'] }}</div>
                </app-table-content>
              </div>

              <!--
                [AC-02] Invoice ID: satu ID per baris. Backend mengirimnya sebagai satu string
                dipisahkan koma untuk 1 SO (retur bisa memicu action di beberapa invoice), jadi
                kolomnya bisa sangat panjang kalau dirender apa adanya.
              -->
              <div *ngSwitchCase="'invoice_code'">
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <div
                    *ngFor="let invoiceCode of invoiceCodes(element); let isLast = last"
                    class="text-nowrap"
                  >
                    {{ invoiceCode }}{{ isLast ? '' : ',' }}
                  </div>
                </app-table-content>
              </div>

              <!-- [AC-01] Ikon detail: membuka halaman Detail SO. -->
              <div
                *ngSwitchCase="'actions'"
                class="d-flex align-items-center justify-content-center"
              >
                <app-table-content
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'icon'"
                >
                  <span
                    (click)="onDetailSo(element)"
                    [inlineSVG]="STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE"
                    class="svg-icon svg-icon-2 cursor-pointer"
                  ></span>
                </app-table-content>
              </div>

              <div *ngSwitchDefault>
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <span>{{ element[tableColumn.key] }}</span>
                </app-table-content>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr
          *matHeaderRowDef="displayedColumns"
          class="fw-bold text-start text-uppercase"
          mat-header-row
        ></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>

    <div class="d-flex justify-content-between pt-4">
      <app-mai-material-bottom-table
        (changePage)="onPageChange($event)"
        [baseDataTableComponent]="dataSource"
        [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
        class="w-100"
      ></app-mai-material-bottom-table>
    </div>
  </div>
</app-modal-form>
